<template>
  <div>
    <b-sidebar
      v-for="(modal, id) in modals"
      :key="id"
      v-bind="modal.config"
      no-header
      sidebar-class="dashboard-modal"
      backdrop
      lazy
      @hidden="stopConfirmingUnload"
    >
      <template v-slot:default="{ hide }">
        <div class="container-fluid">
          <div class="my-3 text-left text-md-right">
            <button
              class="btn btn-white"
              @click="hide"
            >
              <i class="fa fa-close mr-1"></i>
              Close
            </button>
          </div>
          <widget-group
            :title="modal.config.title"
          >
            <widget
              v-for="(widget, i) in modal.widgets"
              :key="`${id}_${i}`"
              v-bind="widget"
            ></widget>
          </widget-group>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<style lang="scss">
.dashboard-modal {
  width: 95%;

  @media screen and (max-width: 480px) {
    width: 100%;
  }
}
</style>

<script>
import Widget from './Widget'
import WidgetGroup from './WidgetGroup'
import { mapGetters } from 'vuex'
import $ from 'jquery'

export default {
  components: {
    Widget,
    WidgetGroup
  },
  computed: {
    ...mapGetters('dashboard', [
      'modals'
    ])
  },
  mounted () {
    // move the DOM element to the bottom of the body
    $('body').append(this.$el)
  },
  methods: {
    stopConfirmingUnload () {
      window.onbeforeunload = null
    }
  }
}
</script>